import axios from 'axios';

class StripeService {
  constructor() {
    // Stripe client-side configuration
    this.publicKey = 'pk_live_51QHYmUP1QIgDOfI7FhRN1IdrSAtUGU4CwPpfv9lCvmi1Vj5MgLqtd7H7TaQ98IEyzIg5jP3Qj6gjaxvHdvp0FzJX00RRlapAkV';
    this.priceId = 'price_1RpNkpP1QIgDOfI7N4vVh4P5'; // Replace with your actual price ID
    this.productName = 'Meal Calculator Pro';
    this.productDescription = 'Unlimited access to the Meal Calculator with premium features';
    this.amount = 999; // $9.99 in cents
    this.currency = 'usd';
  }

  // Initialize Stripe.js
  async initStripe() {
    if (!window.Stripe) {
      // Load Stripe.js if not already loaded
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      document.body.appendChild(script);

      // Wait for script to load
      await new Promise((resolve) => {
        script.onload = resolve;
      });
    }
    return window.Stripe(this.publicKey);
  }

  // Get the correct base URL for the current environment
  getBaseUrl() {
    // Always use the production domain for redirects
    return 'https://www.createmymeal.com';
  }

  // Create a checkout session
  async createCheckoutSession(customerEmail, successUrl, cancelUrl) {
    try {
      const response = await axios.post('/.netlify/functions/create-checkout-session', {
        priceId: this.priceId,
        successUrl,
        cancelUrl,
        customerEmail
      });

      return response.data.sessionId;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw new Error('Failed to create checkout session');
    }
  }

  // Redirect to Stripe Checkout
  async redirectToCheckout(customerEmail) {
    try {
      const stripe = await this.initStripe();

      // Create proper URLs that work with the production domain
      const baseUrl = this.getBaseUrl();
      const successUrl = `${baseUrl}/#/payment-success?session_id={CHECKOUT_SESSION_ID}`;
      const cancelUrl = `${baseUrl}/#/payment-cancelled`;

      console.log('Redirect URLs:', { baseUrl, successUrl, cancelUrl });

      // Try to create a checkout session with our backend first
      try {
        const sessionId = await this.createCheckoutSession(customerEmail, successUrl, cancelUrl);
        console.log('Created session ID:', sessionId);

        // Redirect to checkout with session ID
        const result = await stripe.redirectToCheckout({
          sessionId
        });

        if (result.error) {
          throw new Error(result.error.message);
        }

        return result;
      } catch (backendError) {
        console.warn('Backend checkout session creation failed, using direct Stripe checkout:', backendError);
        
        // Fallback: Direct Stripe checkout (less secure but works)
        const result = await stripe.redirectToCheckout({
          lineItems: [{
            price: this.priceId,
            quantity: 1
          }],
          mode: 'subscription',
          successUrl,
          cancelUrl,
          customerEmail,
          allowPromotionCodes: true,
        });

        if (result.error) {
          throw new Error(result.error.message);
        }

        return result;
      }
    } catch (error) {
      console.error('Error redirecting to checkout:', error);
      throw error;
    }
  }

  // Fallback method - open a hosted checkout page with proper URLs
  openCheckoutPage() {
    // Create the checkout URL with proper return URLs
    const baseUrl = this.getBaseUrl();
    const successUrl = encodeURIComponent(`${baseUrl}/#/payment-success?session_id={CHECKOUT_SESSION_ID}`);
    const cancelUrl = encodeURIComponent(`${baseUrl}/#/payment-cancelled`);

    console.log('Hosted checkout URLs:', {
      baseUrl,
      successUrl: decodeURIComponent(successUrl),
      cancelUrl: decodeURIComponent(cancelUrl)
    });

    // Updated checkout URL with the new Stripe link you provided
    const checkoutUrl = `https://buy.stripe.com/28E9AV7HV0RZ2zw93Wdwc0p?success_url=${successUrl}&cancel_url=${cancelUrl}`;
    
    console.log('Opening checkout URL:', checkoutUrl);

    // Open in the same window to ensure proper redirect
    window.location.href = checkoutUrl;
    return true;
  }

  // Verify a successful payment
  async verifyPayment(sessionId) {
    try {
      const response = await axios.get(`/.netlify/functions/verify-payment?session_id=${sessionId}`);
      return response.data.verified;
    } catch (error) {
      console.error('Error verifying payment:', error);
      return false;
    }
  }
}

export default new StripeService();